var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg73(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_7085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.093 7.60898C28.3061 4.70977 25.2908 1.69453 22.3916 0.907617C20.6145 0.464062 18.2326 0.00761719 15 0C11.768 0.00820312 9.38613 0.464062 7.60898 0.907617C4.70977 1.69512 1.69453 4.70977 0.907617 7.60898C0.464062 9.38613 0.00820312 11.768 0 15C0.00820312 18.2326 0.464062 20.6145 0.907617 22.3916C1.69453 25.2908 4.70977 28.3055 7.60898 29.093C9.38613 29.5365 11.7691 29.9924 15 30.0006C18.2326 29.9924 20.6145 29.5365 22.3916 29.093C25.2908 28.3055 28.3061 25.2908 29.093 22.3916C29.5365 20.6145 29.9924 18.2314 30.0006 15C29.9924 11.768 29.5365 9.38613 29.093 7.60898Z",
    fill: "#FFEEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6431 11.0487V10.8062C20.6431 9.81004 19.833 9 18.8369 9H9.80615C8.81026 9 8 9.81004 8 10.8062V18.9338C8 19.93 8.81026 20.74 9.80615 20.74H19.74C20.7361 20.74 21.5462 19.93 21.5462 18.9338V12.6123C21.5462 11.9451 21.1824 11.3613 20.6431 11.0487Z",
    fill: "url(#paint0_linear_58_7085)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6432 10.8054V11.0493C20.3769 10.8958 20.07 10.8054 19.7401 10.8054H10.2578C10.0096 10.8054 9.80627 10.6021 9.80627 10.3539C9.80627 10.1056 10.0096 9.90234 10.2578 9.90234H19.7401C19.984 9.90234 20.2234 9.93409 20.4492 9.99715C20.5753 10.241 20.6432 10.5166 20.6432 10.8054Z",
    fill: "url(#paint1_linear_58_7085)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8369 13.9678C17.8408 13.9678 17.0308 14.7778 17.0308 15.7739C17.0308 16.77 17.8408 17.5801 18.8369 17.5801H21.5461V13.9678H18.8369Z",
    fill: "#FFD97B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_7085",
    x1: 14.7447,
    y1: 3.06821,
    x2: 14.7447,
    y2: 29.3287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C30B14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_7085",
    x1: 15.2021,
    y1: 9.32284,
    x2: 15.2021,
    y2: 11.8883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C30B14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_7085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg73);
export default __webpack_public_path__ + "static/media/svg73.4b009d99db1594f4dda8e6460d7423b2.svg";
export { ForwardRef as ReactComponent };